import { render } from "./LinkChainIcon.vue?vue&type=template&id=151f1310"
import script from "./LinkChainIcon.vue?vue&type=script&lang=js"
export * from "./LinkChainIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__